import { render, staticRenderFns } from "./TransferResult.vue?vue&type=template&id=bd9808b6&"
import script from "./TransferResult.vue?vue&type=script&lang=js&"
export * from "./TransferResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports